class StayAISubscriptions extends HTMLElement {
	constructor() {
		super();
		this.productJSON = this.getAttribute('productData');
		this.product = JSON.parse(this.productJSON);
		this.productFormId = this.getAttribute('productFormId');
		this.initialVariant = this.getAttribute('currentVariantId');
		this.addToCartButton = null;
		this.tryNowButtonContainer = null;
		this.tryNowBadge = null;
		this.tryNowInitialized = false;

		// Parse dos metacampos de todas as variantes
		try {
			this.variantMetafields = JSON.parse(
				this.getAttribute('variantMetafields') || '{}'
			);
		} catch (e) {
			this.variantMetafields = {};
		}


		window.addEventListener('load', () => this.initTryNow());
		window.addEventListener('trynow:initialized', () => this.initTryNow());
	}

	connectedCallback() {
		this.initWidget();
		this.setupEventListeners();
		// Força atualização inicial
		setTimeout(() => {
			this.forceUpdateDiscountText();
		}, 100);
	}

	initTryNow() {
		if (this.tryNowInitialized) return;
		if (!window.trynow) return;

		const subscriptionLabel = this.querySelector('.subscription-label');
		const subscriptionSavings = this.querySelector('.subscription-savings');
		this.addToCartButton = document.querySelector(
			'.js-addToCartBtn[type="submit"]'
		);
		this.tryNowButtonContainer = document.querySelector(
			'[id*="try_before_you_buy_trynow_cta_button"]'
		);
		this.tryNowBenefits = document.querySelector('#trynow-benefit-container');

		if (!subscriptionLabel || !subscriptionSavings || !this.addToCartButton)
			return;

		subscriptionSavings.remove();
		if (document.querySelector('#purchaseTypeSubscription')?.checked) {
			this.addToCartButton.style.display = 'none';
		}

		this.tryNowInitialized = true;
	}

	getCookieValue(cookieName) {
        let name = cookieName + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let cookieArray = decodedCookie.split(';');
        
        for(let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i].trim();
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return null;
    }

    checkCookieValue(cookieName, valueToCheck) {
        let cookieValue = this.getCookieValue(cookieName);
        return cookieValue === valueToCheck;
    }

	async handleTryNowVisibility(radioButtonValue) {
		let hasPassedTryLink = await window.trynow.hasPassedTryLink();
		this.tryNowBadge = document.querySelector('.trynow-pdp-badge');
		this.trynowSubscriptionBadge = document.querySelector('.trynow-price-badge');
		this.trynowOtpBadge = document.querySelector('.trynow-price-badge-otp');
		this.trynowOtpComparePrice = document.querySelector('.trynow-otp-msrp');
		let isCookieValueMatch = await this.checkCookieValue('_tn_gate_toggle', 'false');
		this.subscriptionContainer = document.querySelector('.rtx-subscription-details-box');

		if (radioButtonValue == 'purchaseTypeSubscription') {
			this.addToCartButton.classList.add('trynow-display-rule')
			this.tryNowButtonContainer.style.display = 'block';
			if(this.tryNowBadge) this.tryNowBadge.style.display = 'block';
			if(this.tryNowBenefits) this.tryNowBenefits.style.display = 'block';
			if(this.subscriptionContainer) this.subscriptionContainer.classList.add('is-visible');

			if(hasPassedTryLink) {
				if(isCookieValueMatch) {
					this.addToCartButton.classList.add('trynow-display-rule')
					this.tryNowButtonContainer.style.display = 'none';
					if(this.trynowSubscriptionBadge) this.trynowSubscriptionBadge.style.display = 'none';
					if(this.trynowOtpBadge) this.trynowOtpBadge.style.display = 'none';
					if(this.trynowOtpComparePrice) this.trynowOtpComparePrice.style.display = 'block';
					if(this.tryNowBadge) this.tryNowBadge.style.display = 'none';

					if(this.subscriptionContainer) {
						this.subscriptionTitleToggleOn = this.subscriptionContainer.querySelector('.subscription-details-title')
						this.subscriptionLabelToggleOn = this.subscriptionContainer.querySelector('.subscription-details-content')
						this.tryNowSubscriptionDetailToggleOn = this.subscriptionContainer.querySelector('.trynow-subscription-detail');
						if(this.subscriptionTitleToggleOn) this.subscriptionTitleToggleOn.style.display = 'block';
						if(this.subscriptionLabelToggleOn) this.subscriptionLabelToggleOn.style.display = 'block';
						if(this.tryNowSubscriptionDetailToggleOn) this.tryNowSubscriptionDetailToggleOn.style.display = 'none';
					}


				} else {
					this.tryNowButtonContainer.style.display = 'block';
					this.addToCartButton.style.display = 'none';
					this.addToCartButton.classList.remove('trynow-display-rule')
					if(this.trynowSubscriptionBadge) this.trynowSubscriptionBadge.style.display = 'block';
					if(this.trynowOtpBadge) this.trynowOtpBadge.style.display = 'block';
					if(this.trynowOtpComparePrice) this.trynowOtpComparePrice.style.display = 'none';
					if(this.tryNowBadge) this.tryNowBadge.style.display = 'block';

					if(this.subscriptionContainer) {
						this.subscriptionTitleToggleOff = this.subscriptionContainer.querySelector('.subscription-details-title')
						this.subscriptionLabelToggleOff = this.subscriptionContainer.querySelector('.subscription-details-content')
						this.tryNowSubscriptionDetailToggleOff = this.subscriptionContainer.querySelector('.trynow-subscription-detail');
						if(this.subscriptionTitleToggleOff) this.subscriptionTitleToggleOff.style.display = 'none';
						if(this.subscriptionLabelToggleOff) this.subscriptionLabelToggleOff.style.display = 'none';
						if(this.tryNowSubscriptionDetailToggleOff) this.tryNowSubscriptionDetailToggleOff.style.display = 'block';
					}
				}
			} else {
				if(this.trynowSubscriptionBadge) this.trynowSubscriptionBadge.style.display = 'none';
				if(this.trynowOtpBadge) this.trynowOtpBadge.style.display = 'none';
				if(this.trynowOtpComparePrice) this.trynowOtpComparePrice.style.display = 'block';

				if(this.subscriptionContainer) {
					this.subscriptionTitle = this.subscriptionContainer.querySelector('.subscription-details-title')
					this.subscriptionLabel = this.subscriptionContainer.querySelector('.subscription-details-content')
					this.tryNowSubscriptionDetail = this.subscriptionContainer.querySelector('.trynow-subscription-detail');
					if(this.subscriptionTitle) this.subscriptionTitle.style.display = 'none';
					if(this.subscriptionLabel) this.subscriptionLabel.style.display = 'none';
					if(this.tryNowSubscriptionDetail) this.tryNowSubscriptionDetail.style.display = 'block';
				}
			}

		} else {
			if(this.addToCartButton) this.addToCartButton.style.display = 'block';
			if(this.addToCartButton) this.addToCartButton.classList.add('trynow-display-rule')
			if(this.tryNowButtonContainer) this.tryNowButtonContainer.style.display = 'block';
			if(this.tryNowBadge) this.tryNowBadge.style.display = 'block';
			if(this.tryNowBenefits) this.tryNowBenefits.style.display = 'none';
			if(this.subscriptionContainer) this.subscriptionContainer.classList.remove('is-visible');

			if(hasPassedTryLink) {
				if(isCookieValueMatch) {
					if(this.tryNowButtonContainer) this.tryNowButtonContainer.style.display = 'none';
					if(this.addToCartButton) this.addToCartButton.classList.add('trynow-display-rule');
					if(this.tryNowBadge) this.tryNowBadge.style.display = 'none';

					if(this.trynowSubscriptionBadge) this.trynowSubscriptionBadge.style.display = 'none';
					if(this.trynowOtpBadge) this.trynowOtpBadge.style.display = 'none';
					if(this.trynowOtpComparePrice) this.trynowOtpComparePrice.style.display = 'block';
				} else {
					if(this.addToCartButton) this.addToCartButton.classList.remove('trynow-display-rule')
					if(this.addToCartButton) this.addToCartButton.style.display = 'none';
					if(this.tryNowBadge) this.tryNowBadge.style.display = 'block';

					if(this.trynowSubscriptionBadge) this.trynowSubscriptionBadge.style.display = 'block';
					if(this.trynowOtpBadge) this.trynowOtpBadge.style.display = 'block';
					if(this.trynowOtpComparePrice) this.trynowOtpComparePrice.style.display = 'none';
				}
			} else {
				if(this.trynowSubscriptionBadge) this.trynowSubscriptionBadge.style.display = 'none';
				if(this.trynowOtpBadge) this.trynowOtpBadge.style.display = 'none';
				if(this.trynowOtpComparePrice) this.trynowOtpComparePrice.style.display = 'block';
			}

		}
	}

  initWidget() {
		this.purchaseTypeSubscription = this.querySelector(
			"[for='purchaseTypeSubscription']"
		);
		this.purchaseTypeOneTime = this.querySelector(
			"[for='purchaseTypeOneTime']"
		);
		this.sellingPlanSelector = this.querySelector('.rtx-subscription-dropdown');
		this.subscriptionBox = this.querySelector(
			'[data-retextion-subscription-box]'
		);
		this.radioOneTime = this.querySelector(
			'input[value="purchaseTypeOneTime"]'
		);
		this.radioSubscription = this.querySelector(
			'input[value="purchaseTypeSubscription"]'
		);
		this.sellingPlanGroups = this.product.selling_plan_groups.filter(
			(group) => group.app_id == '5859381'
		);

		const selectedInitialVariant = this.product.variants.find(
			(variant) => variant.id === Number(this.initialVariant)
		);
		this.subscriptionContainer = this.querySelector(
			".rtx-subscription-details-box"
		);
		this.currentVariant = selectedInitialVariant || this.product.variants[0];
		this.updateSellingPlans();
	}

	// Set up event listeners for the purchase type, frequency and variant selectors
	setupEventListeners() {
		const purchaseTypeRadioButtons = this.querySelectorAll(
			'input[name="purchaseType"]'
		);
		const variantSelectors = document.querySelectorAll('[name="id"]');

		// Handle purchase type change
		purchaseTypeRadioButtons.forEach((radio) =>
			radio.addEventListener('change', () => {
				this[
					radio.value === 'purchaseTypeSubscription'
						? 'showSubscriptionBox'
						: 'hideSubscriptionBox'
				]();
				this.updateProductPrice(this.sellingPlanSelector?.value || '');
				if (window.trynow) this.handleTryNowVisibility(radio.value);
			})
		);

		// Handle frequency selector change
		if (this.sellingPlanSelector) {
			this.sellingPlanSelector.addEventListener('change', async (e) => {
				this.updateSellingPlanInput(e.target.value);
				this.updateProductPrice(e.target.value);
				e.target.setAttribute('selected-subscription', e.target.value);
				if(window.trynow) {
					let hasPassedTryLink = await window.trynow.hasPassedTryLink();
					let isCookieValueMatch = await this.checkCookieValue('_tn_gate_toggle', 'false');
					this.subscriptionBadgeFlag = document.querySelector('.trynow-price-badge');
					this.trynowOtpBadgeFlag = document.querySelector('.trynow-price-badge-otp');
					this.trynowOtpComparePriceFlag = document.querySelector('.trynow-otp-msrp');
					
					if(hasPassedTryLink) {
						if(isCookieValueMatch) {
							if(this.subscriptionBadgeFlag) this.subscriptionBadgeFlag.style.display = 'none';
							if(this.trynowOtpBadgeFlag) this.trynowOtpBadgeFlag.style.display = 'none';
							if(this.trynowOtpComparePriceFlag) this.trynowOtpComparePriceFlag.style.display = 'block';
						} else {
							if(this.subscriptionBadgeFlag) this.subscriptionBadgeFlag.style.display = 'block';
							if(this.trynowOtpBadgeFlag) this.trynowOtpBadgeFlag.style.display = 'block';
							if(this.trynowOtpComparePriceFlag) this.trynowOtpComparePriceFlag.style.display = 'none';
						}
					} else {
						if(this.subscriptionBadgeFlag) this.subscriptionBadgeFlag.style.display = 'none';
						if(this.trynowOtpBadgeFlag) this.trynowOtpBadgeFlag.style.display = 'none';
						if(this.trynowOtpComparePriceFlag) this.trynowOtpComparePriceFlag.style.display = 'block';
					}
				}
			});
		}
		// Handle variant change
		variantSelectors.forEach((selector) =>
			selector.addEventListener('change', async ({ target }) => {
				const variantId = Number(target.value);
				this.currentVariant = this.product.variants.find(
					(v) => v.id === variantId
				);
				this.updateSellingPlans();
				this.forceUpdateDiscountText();
				if(window.trynow) {
					let isCookieValueMatchFlag = await this.checkCookieValue('_tn_gate_toggle', 'false');
					this.selectorOption = document.querySelector('.is-selected');
		        	this.selectorOptionValue = this.selectorOption.getAttribute('for');
					let hasPassedTryLink = await window.trynow.hasPassedTryLink();
					
					
					if(isCookieValueMatchFlag) {
						this.subscriptionVariantFlag = document.querySelector('.trynow-price-badge');
						if(this.subscriptionVariantFlag) this.subscriptionVariantFlag.style.display = 'none';
					} else {
						this.subscriptionVariantFlag = document.querySelector('.trynow-price-badge');
						this.trynowOtpBadgeFlag = document.querySelector('.trynow-price-badge-otp');
						if(this.selectorOptionValue == 'purchaseTypeOneTime') {
							this.trynowOtpComparePriceFlag = document.querySelector('.trynow-otp-msrp');
							if(hasPassedTryLink) {
								if(this.subscriptionVariantFlag) this.subscriptionVariantFlag.style.display = 'block';
								if(this.trynowOtpComparePriceFlag)  this.trynowOtpComparePriceFlag.style.display = 'none';
								if(this.trynowOtpBadgeFlag) this.trynowOtpBadgeFlag.style.display = 'block';
							} else {
								if(this.subscriptionVariantFlag) this.subscriptionVariantFlag.style.display = 'none';
								if(this.trynowOtpBadgeFlag) this.trynowOtpBadgeFlag.style.display = 'none';
								if(this.trynowOtpComparePriceFlag)  this.trynowOtpComparePriceFlag.style.display = 'block';
							}
						} else {
							this.trynowOtpComparePriceFlag = document.querySelector('.trynow-otp-msrp');
							if(hasPassedTryLink) {
								if(this.subscriptionVariantFlag) this.subscriptionVariantFlag.style.display = 'block';
								if(this.trynowOtpComparePriceFlag)  this.trynowOtpComparePriceFlag.style.display = 'none';
								if(this.trynowOtpBadgeFlag) this.trynowOtpBadgeFlag.style.display = 'block';
							} else {
								if(this.subscriptionVariantFlag) this.subscriptionVariantFlag.style.display = 'none';
								if(this.trynowOtpBadgeFlag) this.trynowOtpBadgeFlag.style.display = 'none';
								if(this.trynowOtpComparePriceFlag)  this.trynowOtpComparePriceFlag.style.display = 'block';
							}
						}
					}
				}
			})
		);
	}

	// Força atualização do texto de desconto
	forceUpdateDiscountText() {
		// Busca o texto de desconto no mapa de metacampos
		const discountText = this.variantMetafields[this.currentVariant?.id] || '';

		// Atualiza no widget
		const discountTextElements = this.querySelectorAll('.rtx-discount-text');

		discountTextElements.forEach((element, index) => {
			if (discountText) {
				element.textContent = discountText;
				element.style.display = 'block';
			} else {
				element.textContent = '';
				element.style.display = 'none';
			}
		});

		// Atualiza no botão
		const btn = document.querySelector('.js-addToCartBtn');
		const discountElementButton = btn?.querySelector('.atc-discount-text');

		if (discountElementButton) {
			if (discountText) {
				discountElementButton.textContent = discountText;
				discountElementButton.style.display = 'inline';
			} else {
				discountElementButton.textContent = '';
				discountElementButton.style.display = 'none';
			}
		}
	}

	// Populate the subscription frequency selector with selling plans for the current variant
	updateSellingPlans() {
		// Get the selling plans for the current variant
		const stayWidget = this.querySelector(`.stay-ai-subscriptions`);
		const sellingPlans = this.currentVariant.selling_plan_allocations
			.map((spa) =>
				this.sellingPlanGroups
					.find((g) => g.id === spa.selling_plan_group_id)
					?.selling_plans.find((sp) => sp.id === spa.selling_plan_id)
			)
			.filter(Boolean);

		if (sellingPlans.length == 0) {
			this.updateSellingPlanInput('');
			// Don't hide the widget completely - keep it visible for one-time purchases
			if (this.purchaseTypeSubscription) {
				this.purchaseTypeSubscription.style.display = 'none';
			}
			if (this.subscriptionBox) {
				this.subscriptionBox.classList.toggle('is-visible', false);
			}
			// Ensure one-time purchase is selected for products without selling plans
			if (this.purchaseTypeOneTime) {
				this.purchaseTypeOneTime.classList.add('is-selected');
				if (this.radioOneTime) {
					this.radioOneTime.checked = true;
				}
			}
			stayWidget.classList.toggle('is-visible', true); // Keep widget visible

			// Update price for one-time purchase even without selling plans
			this.updateProductPrice('');

			//Hide Subscription Details box		
			if (!this.subscriptionContainer) return	

			this.subscriptionContainer.classList.toggle('is-visible', false);

			return;
		} else {
			// Show subscription options if selling plans exist
			if (this.purchaseTypeSubscription) {
				this.purchaseTypeSubscription.style.display = '';
			}
			stayWidget.classList.toggle('is-visible', true);
			//Display Subscription Details box				
			this.subscriptionContainer?.classList?.toggle('is-visible', true);
		}

		// Clear existing options and populate dropdown
		if (this.sellingPlanSelector) {
			this.sellingPlanSelector.innerHTML = sellingPlans
				.map(
					(plan) =>
						`<option value="${plan.id}">${plan.options[0].value}</option>`
				)
				.join('');
		}

		if (!this.isSubscriptionOptionSelected()) {
			this.addSelectFrequencyOption();
			this.updateSellingPlanInput('');
		} else {
			this.updateSellingPlanInput(sellingPlans[0]?.id || '');
		}

		// Show or hide the subscription frequency selector
		if (this.subscriptionBox) {
			this.subscriptionBox.classList.toggle(
				'is-visible',
				this.isSubscriptionOptionSelected()
			);
		}

		// Update prices
		this.updateProductPrice(
			this.isSubscriptionOptionSelected()
				? this.sellingPlanSelector?.value || ''
				: sellingPlans[0]?.id || ''
		);
	}

	// Add "Select frequency" option to the frequency selector
	addSelectFrequencyOption() {
		if (
			this.sellingPlanSelector &&
			!this.sellingPlanSelector.querySelector('option[value=""]')
		) {
			this.sellingPlanSelector.insertAdjacentHTML(
				'afterbegin',
				'<option value="" selected>Select frequency</option>'
			);
		}
	}

	// Show the subscription frequency selector
	showSubscriptionBox() {
		if (this.subscriptionBox) {
			this.subscriptionBox.classList.toggle('disable', false);
			this.subscriptionBox.classList.toggle('is-visible', true);
		}
		if (this.purchaseTypeSubscription) {
			this.purchaseTypeSubscription.classList.toggle('is-selected', true);
		}
		if (this.purchaseTypeOneTime) {
			this.purchaseTypeOneTime.classList.toggle('is-selected', false);
		}
		if (this.sellingPlanSelector) {
			this.sellingPlanSelector.querySelector('option[value=""]')?.remove();
			this.updateSellingPlanInput(this.sellingPlanSelector.value);
		}
	}

	// Hide the subscription frequency selector
	hideSubscriptionBox() {
		if (!this.frequencyVisible && this.subscriptionBox) {
			this.subscriptionBox.classList.toggle('is-visible', false);
		}
		this.addSelectFrequencyOption();
		if (this.subscriptionBox) {
			this.subscriptionBox.classList.toggle('disable', true);
		}
		if (this.purchaseTypeSubscription) {
			this.purchaseTypeSubscription.classList.toggle('is-selected', false);
		}
		if (this.purchaseTypeOneTime) {
			this.purchaseTypeOneTime.classList.toggle('is-selected', true);
		}
		this.updateSellingPlanInput('');
	}

	// Check if the subscription option is selected
	isSubscriptionOptionSelected() {
		return (
			this.purchaseTypeSubscription?.classList.contains('is-selected') || false
		);
	}

	//Add selling plan input to form with specified selling plan ID
	updateSellingPlanInput(sellingPlanId) {
		const productForm = document.querySelector(
			this.productFormId?.trim()
				? `#${this.productFormId}`
				: `form[action='/cart/add'][data-type='add-to-cart-form']`
		);

		if (!productForm) return;

		// Find or create the hidden input for selling plan
		let sellingPlanInput = productForm.querySelector(
			"input[name='selling_plan']"
		);
		if (!sellingPlanInput) {
			sellingPlanInput = document.createElement('input');
			sellingPlanInput.type = 'hidden';
			sellingPlanInput.name = 'selling_plan';
			sellingPlanInput.value = sellingPlanId || '';
			productForm.appendChild(sellingPlanInput);
		} else {
			sellingPlanInput.value = sellingPlanId || '';
		}
	}
	

  updateProductPrice(sellingPlanId) {
    const selectedSellingPlanAllocation =
      this.currentVariant.selling_plan_allocations.find(
        (spa) => spa.selling_plan_id == sellingPlanId
      );
  
    const sellingPlan = this.sellingPlanGroups
      .find((group) => group.selling_plans.some((sp) => sp.id == sellingPlanId))
      ?.selling_plans.find((sp) => sp.id == sellingPlanId);
  
    const oneTimeLblPrice = this.querySelector('[data-rtx-onetime-price]');
    const subscriptionLblPrice = this.querySelector('[data-rtx-subscription-price]');
    const savingLbl = this.querySelector('.subscription-savings');
  
    const onetimePrice = this.formatMoney(this.currentVariant.price);
    let subscriptionPrice = onetimePrice;
  
    // Update one-time price with compare_at_price if available (matching subscription style)
    if (oneTimeLblPrice) {
      const hasComparePrice =
        this.currentVariant.compare_at_price &&
        this.currentVariant.compare_at_price > this.currentVariant.price;
  
      if (hasComparePrice) {
        const comparePrice = this.formatMoney(this.currentVariant.compare_at_price);
        oneTimeLblPrice.innerHTML = `<s>MSRP ${comparePrice}</s> ${onetimePrice}`;
      } else {
        oneTimeLblPrice.textContent = onetimePrice;
      }
			if(window.trynow && !this.product.type.includes('Wholesale')) {
				const comparePrice = this.formatMoney(this.currentVariant.compare_at_price);
				oneTimeLblPrice.innerHTML = `<div class="trynow-price-badge-cont-otp"><s class="trynow-otp-msrp">MSRP ${comparePrice}</s><span style="display: none;" class="trynow-price-badge-otp">$0 Now</span>${onetimePrice}</div>`;
			}
    }
  
    // Update subscription price only if selling plans exist
    if (selectedSellingPlanAllocation && subscriptionLblPrice) {
      subscriptionPrice = this.formatMoney(selectedSellingPlanAllocation.price);
			subscriptionLblPrice.textContent = subscriptionPrice
  
      // TryNow override: when TryNow is active and subscription is selected,
      // show struck-through subscription price followed by $0.00
      if (window.trynow && this.isSubscriptionOptionSelected()) {
        subscriptionLblPrice.innerHTML = `<div class="trynow-price-badge-cont"><span class="trynow-price-badge">$0 Now</span>${subscriptionPrice}</div>`;
      } 
  
      // Calculate and update savings label
      let discount =
        this.currentVariant.price - selectedSellingPlanAllocation.price;
  
      if (discount > 0 && savingLbl) {
        if (sellingPlan?.price_adjustments[0].value_type === 'percentage') {
          discount = `${sellingPlan.price_adjustments[0].value}%`;
        } else {
          discount = this.formatMoney(discount);
        }
        if (savingLbl.textContent !== discount) savingLbl.textContent = discount;
      } else if (savingLbl) {
        savingLbl.textContent = '';
      }
    }
  

		// Update discount text in widget and button
		this.forceUpdateDiscountText();

		// Always update AddToCartButton text
		this.updateAddToCartButton(onetimePrice, subscriptionPrice);
  }

	// Separate method to handle ATC button updates
	updateAddToCartButton(onetimePrice, subscriptionPrice) {
		const btn = document.querySelector('.js-addToCartBtn');
		if (btn) {
			const labelText = btn.querySelector('.atc-price-text');
			const priceText = btn.querySelector('.atc-price');

			if (labelText && priceText) {
				// Check if strikethrough pricing is enabled
				const showStrikethrough =
					window.sectionSettings?.showStrikethroughPricing || false;

				// Check if current variant has compare_at_price
				const hasComparePrice =
					this.currentVariant.compare_at_price &&
					this.currentVariant.compare_at_price > this.currentVariant.price;
				const comparePrice = hasComparePrice
					? this.formatMoney(this.currentVariant.compare_at_price)
					: null;

				if (
					this.isSubscriptionOptionSelected() &&
					subscriptionPrice !== onetimePrice
				) {
					labelText.textContent = 'SUBSCRIBE - ';
					if (showStrikethrough && hasComparePrice) {
						priceText.innerHTML = `<s>${comparePrice}</s> ${subscriptionPrice}`;
					} else if (showStrikethrough) {
						priceText.innerHTML = `<s>${onetimePrice}</s> ${subscriptionPrice}`;
					} else {
						priceText.textContent = subscriptionPrice;
					}
				} else {
					labelText.textContent = 'ADD TO CART - ';
					if (showStrikethrough && hasComparePrice) {
						priceText.innerHTML = `<s>${comparePrice}</s> ${onetimePrice}`;
					} else {
						priceText.textContent = onetimePrice;
					}
				}
			}
		}
	}

	// Toggle checked state based on the currently checked radio button
	toggleRadioButtons() {
		if (this.radioOneTime && this.radioSubscription) {
			this.radioOneTime.checked = !this.radioOneTime.checked;
			this.radioSubscription.checked = !this.radioSubscription.checked;
		}
	}

	// Format money based on Shopify's active currency
	formatMoney(money) {
		const { Shopify, theme } = window;
		const currency = Shopify?.currency?.active || 'USD';
		const locale = Shopify?.locale || 'en';
		const hasShopifyFormatMoney =
			Shopify && typeof Shopify?.formatMoney === 'function';
		const hasThemeUtilsFormatMoney =
			theme?.utils && typeof theme?.utils?.formatMoney === 'function';
		const formattedMoney = (money / 100).toFixed(2);
		let formatted;

		const currencyFormatter = new Intl.NumberFormat(locale, {
			currency,
			style: 'currency',
		});

		if (!hasShopifyFormatMoney && !hasThemeUtilsFormatMoney) {
			return currencyFormatter.format(Number(formattedMoney));
		}

		formatted = hasShopifyFormatMoney
			? Shopify.formatMoney(money)
			: theme.utils.formatMoney(money);

		return formatted || currencyFormatter.format(Number(formattedMoney));
	}
}

// Define the custom element
customElements.define('purchase-options-rtx', StayAISubscriptions);
